import { Teammate } from '@flipdish/api-client-typescript';
import { useQuery } from '@tanstack/react-query';

import { teammatesService } from '../../../services/teammates.service';

const { AppAccessLevelEnum } = Teammate;

// StoreOwner is the legacy alias of PropertyOwner, see RMS/utils/permissions.ts.
const ownerAccessLevels = [
  AppAccessLevelEnum.Owner,
  AppAccessLevelEnum.ManagedOwner,
  AppAccessLevelEnum.PropertyOwner,
  AppAccessLevelEnum.StoreOwner,
];

const isCounted = ({ AppAccessLevel, Email }: Teammate) =>
  AppAccessLevel !== AppAccessLevelEnum.Integrator &&
  !Email?.toLowerCase().endsWith('@flipdish.com');

const isOwner = ({ AppAccessLevel }: Teammate) =>
  ownerAccessLevels.some((level) => level === AppAccessLevel);

export const isOwnerOnlyOrg = (teammates: Teammate[]): boolean =>
  teammates.filter(isCounted).every(isOwner);

export const useIsOwnerOnlyOrg = (appId: string, enabled: boolean): boolean => {
  const { data: teammates } = useQuery({
    queryKey: ['getTeammates', appId],
    queryFn: () => teammatesService.getTeammates(appId),
    enabled: enabled && Boolean(appId),
    retry: 1,
    staleTime: 1000 * 60 * 10,
  });

  return teammates ? isOwnerOnlyOrg(teammates) : false;
};
